import { Fragment, useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AssessmentContext } from "../../contexts/assessments";
import bgImage from '../../assets/images/bgImage.png';
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BannerReport from "../../components/BannerReport";
import WelcomeReport from "../../components/WelcomeReport";
import BlockReportProfile from "../../components/BlockReportProfile";

const ReportAdmin = () => {

    const navigate = useNavigate();
    const {slugAssessment, userId}=useParams();
    const [currentAssessment, setCurrentAssessment] = useState();
    const {getAssessmentBySlug,isLoading} = useContext(AssessmentContext);
  
    useEffect(() => {
      if(!isLoading){
          const assessment = getAssessmentBySlug(slugAssessment);
          if(!assessment){
                navigate('/');
                return;
          }
          setCurrentAssessment(assessment);
      }
    }, [isLoading]);
  
    return (
      <Box sx={{backgroundImage:`url(${bgImage})`,backgroundRepeat:"no-repeat",backgroundSize:"cover",padding:"100px 0px !important"}}>
        {
          isLoading && <CircularProgress/>
        }
        { 
          currentAssessment && !isLoading && <>
            <Box className="padLeft" display="flex" flexDirection="column">
              <Typography component={"div"} variant='h2' color='primary' fontWeight={500} dangerouslySetInnerHTML={{ __html: `${currentAssessment?.name}` }}></Typography>
              <WelcomeReport text={currentAssessment?.report?.welcome} mainImage={currentAssessment?.mainImage} howToUse={currentAssessment?.report?.howToUse}/>
            </Box>
            {
              currentAssessment?.blocks?.map((b,i)=>(
                <Fragment key={i}>
                  <BannerReport number={i+1} name={b.name} color={b.color}/>
                  <BlockReportProfile info={currentAssessment?.report?.blocksInfo} blockId={b._id} color={b.color} questionLength={b.questions.length} userId={userId}/>
                </Fragment>
              ))
            }
            <Box className="padLeft padRight" display="flex" justifyContent={"space-between"}>
              <Button variant="contained" color="secondary" startIcon={<PrintIcon/>}>PRINT</Button>
              <Button component={Link} to={`/profile/${userId}`} variant="contained" startIcon={<ArrowBackIcon className="invertIcon"/>}>BACK</Button>
            </Box>
          </>
        }
      </Box>
    )
}

export default ReportAdmin